import { ActionType, getType } from 'typesafe-actions';
import * as actions from './actions';
import type { IBusinessInfoState } from './types';

const INITIAL_STATE: IBusinessInfoState = {
  showClosingScene: true,
};

type BusinessInfoActions = ActionType<typeof actions>;

function reducer(state: IBusinessInfoState, action: BusinessInfoActions) {
  if (!state) {
    state = INITIAL_STATE;
  }
  switch (action.type) {
    case getType(actions.setBusinessInfo):
      return { ...state, ...action.payload };
    default:
      return state;
  }
}

export default reducer;
export type { IBusinessInfoState };
